module.exports = __webpack_public_path__ + "static/img/p1.dd9520c0.png";